import { render, staticRenderFns } from "./buyedGuide.vue?vue&type=template&id=f70eea36&scoped=true"
import script from "./buyedGuide.vue?vue&type=script&lang=js"
export * from "./buyedGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70eea36",
  null
  
)

export default component.exports